module.exports = __webpack_public_path__ + "static/media/sign-up-img-1.1ae58424.png";